import { useState } from "react";
import { Link } from "react-router-dom";

function Hero({ mode }) {

  // 🔥 CHANGE THIS WHEN HOSTING
const API_URL = process.env.REACT_APP_API_URL;
  // STATE
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    className: ""
  });

  // HANDLE INPUT
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/api/inquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("✅ Inquiry Sent Successfully!");

        setFormData({
          fullName: "",
          phone: "",
          className: ""
        });

      } else {
        alert("❌ Error sending inquiry");
      }

    } catch (error) {
      console.log("Error ❌", error);
      alert("❌ Cannot connect to server");
    }
  };

  return (
    <div className={`hero ${mode === "school" ? "school-mode" : "college-mode"}`}>

      {/* LEFT SIDE */}
      <div className="hero-left">

        {mode === "college" ? (
          <>
            <p>
              AFFILIATED TO{" "}
              <a
                href="https://sndt.digitaluniversity.ac/"
                target="_blank"
                rel="noopener noreferrer"
              >
                S.N.D.T. WOMEN'S UNIVERSITY, MUMBAI
              </a>
              <br />
              AISHE CODE : C-76858
            </p>

            <h1>TEJKIRTI SENIOR WOMEN’S COLLEGE</h1>

            <p>"Empowering Women Through Education & Excellence"</p>

            <div className="hero-buttons">
              <Link to="/admission" className="btn-primary">
                Apply Now
              </Link>

              <Link to="/about" className="btn-secondary">
                Learn More
              </Link>
            </div>
          </>
        ) : (
          <>
            <p>Recognized by Early Childhood Education Board</p>

            <h1>TEJKIRTI LITTLE STAR PRE-SCHOOL</h1>

            <p>"Play • Learn • Grow Together 🌈"</p>

            <div className="hero-buttons">
              <Link to="/admission" className="btn-primary">
                Enroll Now
              </Link>

              <Link to="/about" className="btn-secondary">
                Explore More
              </Link>
            </div>
          </>
        )}

      </div>

      {/* RIGHT SIDE FORM */}
      <div className="hero-form">

        <h3>Quick Admission Inquiry</h3>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name"
            required
          />

          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            required
          />

          <select
            name="className"
            value={formData.className}
            onChange={handleChange}
            required
          >
            <option value="">
              {mode === "school" ? "Select Class" : "Select Course"}
            </option>

            {mode === "school" ? (
              <>
                <option>Play Group</option>
                <option>Nursery</option>
                <option>Junior KG</option>
                <option>Senior KG</option>
              </>
            ) : (
              <>
                <option>B.A</option>
                <option>B.Sc</option>
                <option>B.Com</option>
              </>
            )}
          </select>

          <button type="submit">
            {mode === "school"
              ? "Get Admission Details"
              : "Get Admission Info"}
          </button>

        </form>

      </div>

    </div>
  );
}

export default Hero;